var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagMar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2111 3341)",
    fill: "#fff",
    opacity: 0.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_MAR",
    transform: "translate(-2111 -3341)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_marrocos",
    transform: "translate(2090.543 3341)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_526",
    "data-name": "Ret\\xE2ngulo 526",
    width: 102.826,
    height: 60,
    transform: "translate(0 0)",
    fill: "#b01f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8193",
    "data-name": "Caminho 8193",
    d: "M260.331,14.7l-13.238.012,15.065,11.5,2.263-1.725L255.281,17.5l4.179-.012Z",
    transform: "translate(-213.008 10.503)",
    fill: "#296437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8194",
    "data-name": "Caminho 8194",
    d: "M263.693,20.219l-4.1-13.238-5.751,18.624,2.259,1.723,3.492-11.287,1.3,4.178Z",
    transform: "translate(-208.186 4.987)",
    fill: "#296437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8195",
    "data-name": "Caminho 8195",
    d: "M264.725,22.891,275.438,14.7H256.8l-.863,2.789h11.294l-3.37,2.6Z",
    transform: "translate(-206.689 10.503)",
    fill: "#296437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8196",
    "data-name": "Caminho 8196",
    d: "M257.2,26.791l10.709,8.162-5.753-18.622h-2.8l3.49,11.3-3.387-2.573Z",
    transform: "translate(-205.788 11.665)",
    fill: "#296437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8197",
    "data-name": "Caminho 8197",
    d: "M255.036,19.916l-4.082,13.25,15.063-11.515-.863-2.8L256.02,25.84l1.284-4.178Z",
    transform: "translate(-210.25 13.466)",
    fill: "#296437"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMar);
export default __webpack_public_path__ + "static/media/flag_MAR.91c7cbe0d3db9185ca8912f3122ede4e.svg";
export { ForwardRef as ReactComponent };